// extracted by mini-css-extract-plugin
module.exports = {"userLiquidity":"UserLiquidity-module--userLiquidity--2y3uV"};